import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "task-add",
  "use": "task-add-usage",
  "viewBox": "0 0 80.2 87.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80.2 87.9\" id=\"task-add\"><path d=\"M30 52.4l8.3 10.8c-.7 1.7-1.1 3.5-1.2 5.4-.7 9.7 6.7 18.1 16.4 18.8 2.2.2 4.4-.1 6.5-.8L47.5 72.2 58.1 63l12.5 14.4c.9-2 1.5-4.1 1.6-6.3.7-9.7-6.6-18.1-16.3-18.8-2.5-.2-5.1.2-7.5 1.1l-7.8-10.2-4.6-5.4-2.7-3.8c1.2-2.2 1.9-4.7 2.1-7.3.7-9.6-6.6-18-16.3-18.7-2.2-.2-4.4.1-6.5.8l12.5 14.4-10.6 9.3L2 18C1 20 .5 22.1.3 24.3-.3 34.1 7 42.5 16.7 43.1c1.8.1 3.7 0 5.5-.5l3.2 4.3 4.6 5.5zM79.1 15.2H66.5V2.6c0-.6-.5-1.1-1.1-1.1h-6.9c-.6 0-1.1.5-1.1 1.1v12.6H44.7c-.6 0-1.1.5-1.1 1.1v6.9c0 .6.5 1.1 1.1 1.1h12.6v12.6c0 .6.5 1.1 1.1 1.1h6.9c.6 0 1.1-.5 1.1-1.1V24.3H79c.6 0 1.1-.5 1.1-1.1v-6.9c.1-.6-.4-1.1-1-1.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/task-add.svg
// module id = w5ay
// module chunks = 1